import { useEffect, useState } from 'react';
import type { MapConfig } from '@/lib/api/map';
import { loadMapConfig, peekMapConfig } from '@/lib/map/map-cache';

export function useMapConfig(): {
  config: MapConfig | null;
  error: string | null;
  loading: boolean;
} {
  const [config, setConfig] = useState<MapConfig | null>(() => peekMapConfig());
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(() => peekMapConfig() == null);

  useEffect(() => {
    if (peekMapConfig()) {
      setConfig(peekMapConfig());
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    void loadMapConfig()
      .then((loaded) => {
        if (!cancelled) {
          setConfig(loaded);
          setError(null);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError('לא ניתן לטעון שכבות מפה');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { config, error, loading };
}
